export class DemoConfig {
    DemoMode: boolean;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/demoConfig.ts